export default "__VITE_ASSET__461c4700__"